export enum FieldType {
  TEXT_FIELD = 'textfield',
  PASSWORD = 'password',
  EMAIL = 'email',
  DIVIDER = 'divider',
  INTEGER = 'integer',
  FLOAT = 'float',
  CHECKBOX = 'checkbox',
  SELECT = 'select',
  AUTOCOMPLETE = 'autocomplete',
  TEXT_AREA = 'textarea',
}

export interface FieldConfig {
  type: FieldType;
  identifier?: string;
  label?: string; // translation key
  placeholder?: string;
  placeholderSlug?: string; // translation key
  initialValue?: never | string;
  options?: Option[];
  disabled?: boolean;
  additionalText?: string;
  validation?: Validation;
  errorMessage?: string; // translation key,
  compareMessage?: string; // translation key,
  valueToCompare?: string;
  messageParams?: {
    [key: string]: string;
  };
}

export enum ValidationType {
  REQUIRED = 'required',
  PATTERN = 'pattern',
  MATCH = 'match',
  RULES = 'rules',
}

export interface RuleCheckItem {
  method: string;
  params: (string | number)[];
  result?: boolean;
  errorMessage: string;
}

export interface RuleCheckResult {
  result: boolean;
  errorMessage: string;
  params: { [key: string]: string };
}

export type Validation = {
  [key in ValidationType]?: string | RegExp | boolean | RuleCheckItem[];
};

export interface Option {
  label: string;
  value: string;
}

export interface FormFieldRendererProps {
  field: FieldConfig;
}

export interface InputProps {
  field: FieldConfig;
  float?: boolean;
  numRows?: number;
  onChange?: (value: string) => void;
  value?: string;
}

export interface AuthFormProps {
  onChange: (name: string, value: string) => void;
  fieldValues?: { [key: string]: string };
}

export interface FormData {
  formFields: FieldConfig[];
}
